import {loadErrorMessages, loadDevMessages} from '@apollo/client/dev';
import {App} from 'vue';

import {FAILED_REFRESHED_TOKEN_ERROR_CAUSE} from './consts';
import {env, initEnvironmentVariables} from './utils/env';

if (process.env.NODE_ENV === 'development') {
	loadDevMessages();
}
loadErrorMessages();

void (async () => {
	try {
		await initEnvironmentVariables();
		if (env('VITE_REDIRECT_TO', '')) {
			const target = new URL(env('VITE_REDIRECT_TO'));
			target.pathname = window.location.pathname;
			target.search = window.location.search;
			target.hash = window.location.hash;
			window.location.href = target.toString();
			return;
		}
	} catch (err) {
		console.error(err);

		await mountErrorPage(err instanceof Error ? err.message : 'An error occurred while communicating with the server.');
		return;
	}

	try {
		await import('./authorization').then(({signin}) => signin());
	} catch (err) {
		console.error(err);
		await mountErrorPage('Failed to contact the sign-in service.');
		return;
	}

	try {
		await import('./initApplicationState').then(({default: initApplicationState}) => initApplicationState());
	} catch (err) {
		// oxlint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
		const statusCode = typeof err === 'object' ? (err as any).networkError?.statusCode : undefined;
		if (statusCode && typeof statusCode === 'number' && statusCode === 403) {
			await mountErrorPage('Insufficient permissions: please contact your administrator');
		} else {
			console.error(err);
			await mountErrorPage('An error occurred while communicating with the server.');
		}
		return;
	}

	try {
		await import('./mountApp').then(({default: mountApp}) => {
			app = mountApp();
		});
	} catch (err) {
		console.error(err);
		await mountErrorPage('An error occurred while loading the application.');
		return;
	}
})();

async function mountErrorPage(message: string) {
	await import('./mountErrorPage').then(({default: mountErrorPage}) => mountErrorPage(message));
}

let app: App<Element>;
window.onerror = (message, source, lineno, colno, error) => {
	if (error?.cause === FAILED_REFRESHED_TOKEN_ERROR_CAUSE) {
		app?.unmount();
		void mountErrorPage('An authentication error occurred');
		// To avoid logging into the console
		return true;
	}
};
